import React, { useState, useContext } from 'react'
import { Accordion, Icon, List } from 'semantic-ui-react'
import moment from 'moment-timezone'
import DataContext from '../../../contexts/DataContext'

const Transactions = ({ job }) => {
  const { advisor } = useContext(DataContext)
  const [show, setShow] = useState(false)
  const transactions = job.payment
    ? job.bonuses.concat(job.payment)
    : job.bonuses

  if (transactions.length === 0) {
    return <div />
  }

  transactions.sort((a, b) => a.createdAt - b.created)

  const bonusesAmounts = job.bonuses
    .map((b) => b.amount)
    .reduce((sum, amount) => sum + amount, 0)
  const paymentAmount = job.payment?.amount || 0
  const total = (paymentAmount + bonusesAmounts).toFixed(2)

  return (
    <Accordion>
      <Accordion.Title active={show} onClick={() => setShow(!show)}>
        {`$${total} paid total`}
        <Icon name="dropdown" />
      </Accordion.Title>
      <Accordion.Content active={show}>
        <List bulleted>
          {transactions.map((t) => (
            <List.Item key={t.createdAt}>
              {`$${t.amount} paid via ${t.method} | ${moment(t.createdAt)
                .tz(advisor.timeZone)
                .format('LL')}`}
            </List.Item>
          ))}
        </List>
      </Accordion.Content>
    </Accordion>
  )
}

export default Transactions
